/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `radio` - radio
 * * `checkbox` - checkbox
 * * `file` - file
 * @export
 */
export const AnswerTypeEnum = {
  radio: 'radio',
  checkbox: 'checkbox',
  file: 'file',
} as const;
export type AnswerTypeEnum = (typeof AnswerTypeEnum)[keyof typeof AnswerTypeEnum];

export function instanceOfAnswerTypeEnum(value: any): boolean {
  for (const key in AnswerTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(AnswerTypeEnum, key)) {
      if ((AnswerTypeEnum as Record<string, AnswerTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function AnswerTypeEnumFromJSON(json: any): AnswerTypeEnum {
  return AnswerTypeEnumFromJSONTyped(json, false);
}

export function AnswerTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerTypeEnum {
  return json as AnswerTypeEnum;
}

export function AnswerTypeEnumToJSON(value?: AnswerTypeEnum | null): any {
  return value as any;
}
